import { ReactiveStore } from "./lib/reactiveStore.js";
import $ from "./lib/qsa";

// only these properties get hash memory
// we could also probably just do primitive values, but that's no fun
const SERIALIZED = "districtNumber districtColor markerColor".split(" ");

let DEFAULTS = {
  markerColor: "type",
  districtColor: "term",
};

let app = $.one("main.app");
export let store = new ReactiveStore({
  ...DEFAULTS,

  get districtColor() {
    return app.dataset.districtColor || "term";
  },

  set districtColor(value) {
    return app.dataset.districtColor = value;
  },

  get markerColor() {
    return app.dataset.markerColor;
  },

  set markerColor(value) {
    return app.dataset.markerColor = value;
  },

  // handle school filtering for the select boxes
  get districtSchoolOptions() {
    if (!this.profiles) return [];
    return Object.values(this.profiles)
      .filter(p => this.districtNumber ? p.subdistrict == this.districtNumber : true)
      .map(s => ({
        label: s.name,
        value: s.id,
      }))
      .sort((a, b) => a.label < b.label ? -1 : 1);
  },

  get schoolNumber() {
    return this.selectedSchool?.id;
  },

  set schoolNumber(value) {
    if (!this.profiles) return;
    let school = this.profiles[value];
    store.data.selectedSchool = school;
    store.data.districtNumber = school.subdistrict;
  },
});

// update the hash when the data object changes
store.addEventListener("update", e => {
  let entries = [];
  let { raw } = store;
  for (let key of SERIALIZED) {
    if (raw[key] && raw[key] != DEFAULTS[key]) {
      entries.push([key, raw[key]]);
    }
  }
  let hash = new URLSearchParams(entries);
  window.location.hash = hash;
})

// update on startup
let startupParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
for (let [key, value] of startupParams.entries()) {
  store.data[key] = value;
}